import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import i18n from "../../../../i18n/i18n";
import { formatDate, formatTimeWithLocale } from "../../../../utils/formatters";

export interface SubmittedDateCellProps {
  date: string | null;
}

const SubmittedDateCell = ({ date }: SubmittedDateCellProps) => {
  const theme = useTheme();
  const formattedDate = formatDate(date ?? null, i18n.language, false, true);

  return (
    <Box data-testid="submitted-date-cell">
      <Typography
        data-testid="date"
        sx={{
          fontWeight: theme.tokens.FuelFontWeightRegular,
          fontSize: theme.tokens.FuelFontSizeHeading5,
          lineHeight: theme.tokens.FuelSpacing6,
        }}
      >
        {formattedDate === "NA" ? "" : formattedDate}
      </Typography>
      <Typography
        sx={{
          fontSize: theme.tokens.FuelFontSizeHeading5,
          color: theme.tokens.FuelColorTextTertiary,
          lineHeight: theme.tokens.FuelSpacing6,
        }}
        data-testid="time"
      >
        {formatTimeWithLocale(date ?? null, i18n.language)}
      </Typography>
    </Box>
  );
};

export default SubmittedDateCell;
